import React, {useState} from 'react';
import classes from './index.css';
import TransitionExpand from './TransitionExpand';
import _ from 'lodash';
import CompletedCourseGrades from './CompletedCourseGrades';
import ActivityCompDetails from './ActivityCompDetails';
export default function CompletedCourseDetails(props){
    // console.log('completed course details props');
    // console.log(props);
    //redundant but quick to develop /shrug
    const [tasklist, setTasklist] = useState( () => {
        var lasktisk = [];
        props.compidlist.forEach(compid => {
            var comp= props.fullcomplist[compid]
            var ksat=comp.idnumber.match(/[KSATksat]/g).pop()
            comp['ksat']=ksat.toLowerCase()
            comp['hidden']=true
            if (ksat.toLowerCase() == "t"){
                lasktisk.push(comp)
            }
        })
        return lasktisk;
    });
    const [ksalist, setKsalist] = useState( () => {
        var listOksa = [];
        props.compidlist.forEach(compid => {
            var comp=props.fullcomplist[compid]
            var ksat=comp.idnumber.match(/[KSATksat]/g).pop()
            comp['ksat']=ksat.toLowerCase()
            comp['hidden']=true
            if (ksat.toLowerCase() == "t"){
                //do nothin
            }else{
                listOksa.push(comp);
            }
        })
        return listOksa;
    })

    const [savedChildData, setSavedChildData] = useState({});
    const [keywords, setKeywords] = useState("");
    const [expandAllComps, setExpandAllComps] = useState(false);
    const [expandAllActivities, setExpandAllActivities] = useState(false);
    const [showCourseDescription, setShowCourseDescription] = useState(false);


    const get_final_grade_pct = (final_grade) => {
        var rawmax=final_grade.rawgrademax
        var earned=final_grade.finalgrade
        if(rawmax == 0){
            rawmax = 1
        }
        var pct = Math.round(100 * earned / rawmax)
        return pct
    }
    const saveChildData = (stuff, key) => {
        var scd = _.cloneDeep(savedChildData);
        scd[key]=stuff

        if(!_.isEqual(scd, savedChildData))
            setSavedChildData(scd);
    }
    const filterComps = () => {
        setKeywords("");
    }
    /*
    const toggleFilter = (filterName) => {
        //console.log(`toggling ${filterName}`)
        this[filterName]=!this[filterName]
    }
    */
    const checkFilter = (comp) =>{
        if(keywords.length){
            //probably unnecessary because idk that replace all actually changes the variable value
            var keywrds = _.cloneDeep(keywords);
            let regexp=new RegExp(keywrds.replaceAll(' ', '|'), "i")
            if(regexp.test(`${comp.idnumber} ${comp.description}`)){
                return true
            } else {
                return false
            }
        }
        return true
    }


    const getKsaActList = () =>{
        var ksaActList=[]
        ksalist.forEach(ksa => {
            var ksaAct = {}
            ksaAct['competency']=ksa
            ksaAct['activities']={}
            Object.keys(this.course.activities).forEach(actid => {
                var act=this.course.activities[actid]
                if(act.competencies.filter(ksaid => ksaid == ksa.id).length){
                    ksaAct['activities'][actid]=act
                }
            })
            ksaActList.push(ksaAct)
        })
        return ksaActList
    }

    const getKsaModList = () =>{
        var ksaModList=[]
        ksalist.forEach(ksa =>{
            let ksaMods={}
            ksaMods['competency']=ksa
            ksaMods['module']={}
            Object.keys(props.course.course_modules).forEach(cmid => {
                let cm=props.course.course_modules[cmid]
                if (typeof cm.competencies[ksa.id] != "undefined") {
                    ksaMods.module[cmid]=cm
                }
            })
            //ksaModList[ksa.id]=ksaMods
            ksaModList.push(ksaMods)
        })
        return ksaModList
    }

    const getTaskModList = () =>{
        var taskModList=[]
        tasklist.forEach(task =>{
            let taskMods={}
            taskMods['competency']=task
            taskMods['module']={}
            Object.keys(props.course.course_modules).forEach(cmid => {
                let cm=props.course.course_modules[cmid]
                if (typeof cm.competencies[task.id] != "undefined") {
                    taskMods.module[cmid]=cm
                }
            })
            //taskModList[task.id]=taskMods
            taskModList.push(taskMods)
        })
        return taskModList
    }

    const getTksaModList = () =>{
        return [...getTaskModList(), ...getKsaModList()]
    }


    var descriptPressed = showCourseDescription ? classes.btnPressed : classes.btnNotPressed;
    var gradesPressed = props.showGrades ? classes.btnPressed : classes.btnNotPressed;
    var competenciesPressed = props.showCompetencies ? classes.btnPressed : classes.btnNotPressed;
    var activitiesPressed = props.showActivities ? classes.btnPressed : classes.btnNotPressed;
    var filterAct = expandAllComps ? classes.filterActive : ''
    var filterActs2 = expandAllActivities ? classes.filterActive : ''
    return(
        <div
            className={classes.courseDetails}>
            <div className={classes.fullFlex}>
                <h3>
                    {props.course.name}
                </h3>
            </div>
            <div className={classes.buttonRow}>
                <div
                    className={classes.btnLvl3 + ' ' + descriptPressed}
                    onClick={() => {setShowCourseDescription(!showCourseDescription)}}>
                        <h4>{props.course.course.shortname} Description</h4>
                </div>
                <div className={classes.btnLvl3 + ' ' + gradesPressed}
                    onClick={() => {props.toggleShowGrades()}}>
                        <h4>{props.course.course.shortname} Grades</h4>
                </div>
                <div className={classes.btnLvl3 + ' ' + competenciesPressed}
                    onClick={() => {props.toggleShowCompetencies()}}>
                        <h4>{props.course.course.shortname} Competencies</h4>
                </div>
                <div className={classes.btnLvl3 + ' ' + activitiesPressed}
                    onClick={() => {props.toggleShowActivities()}}>
                        <h4>{props.course.course.shortname} Activities</h4>
                </div>
            </div>

            <TransitionExpand
                duration={500} height={showCourseDescription ? 'auto' : 0}>
                {showCourseDescription && (
                    <div className={classes.detailBox}>
                        <h4>Course Description</h4>
                        <div
                            className={classes.courseDesc}
                            dangerouslySetInnerHTML={{__html: props.course.course.coursedesc}}>
                            
                        </div>
                    </div>
                )}
            </TransitionExpand>

            <TransitionExpand 
                duration={500} height={props.showGrades ? 'auto' : 0}>
                {props.showGrades && (
                    <div className={classes.detailBox}>
                        <h4>Course Grades</h4>
                        <CompletedCourseGrades
                            courseGradeCats={props.course.grade_categories}
                            finalScore={props.course.final_score}
                            parentSaved={savedChildData['showGrades']}
                            // @save-please="saveChildData($event, 'showGrades')"
                        />
                    </div>
                )}
            </TransitionExpand>
            <TransitionExpand 
                duration={500} height={props.showCompetencies ? 'auto' : 0}>
                {props.showCompetencies && (
                    <div className={classes.detailBox}>
                        <h4>Competencies Covered</h4>
                        <div className={classes.compFilters + ' ' + classes.noPrint}>
                            <form action=""
                             onSubmit={e => {e.preventDefault(); filterComps();}}
                             autoComplete="off">
                                <div className={classes.keywordsearch}>
                                    <input type="text" name="search" value={keywords} onChange={(e) => {setKeywords(e.target.value)}}/>
                                    <input type="submit" value="Clear"/>
                                </div>
                                <div className={classes.buttonsearch}>
                                    <div
                                        className={classes.expandAllComps + ' ' + filterAct}
                                        onClick={() => {setExpandAllComps(!expandAllComps)}}
                                        >
                                        Expand All Competencies
                                    </div>
                                </div>
                            </form>
                        </div>
                        {Object.keys(getTksaModList()).map((iId, kee) => {
                            //ik its suboptimal, but im in a hurry
                            var tksamodlist = getTksaModList()
                            var comp = tksamodlist[iId];
                            return(
                                <ActivityCompDetails
                                    key={kee}
                                    activities={props.course.activities}
                                    modules={props.course.course_modules}
                                    competency={comp.competency}
                                    showDetails={props.showCompActivities[comp.competency.id]}
                                    compMods={tksamodlist.filter(i => i.competency.id == comp.competency.id)[0]}
                                    expandAll={expandAllComps}
                                    keywords={keywords}
                                    toggleShowCompActivities={() => {props.toggleShowCompActivities(comp.competency.id, props.courseid)}}
                                />  
                            );
                        })}
                        
                    </div>
                )}
            </TransitionExpand>
            <TransitionExpand 
            duration={500} height={props.showActivities ? 'auto' : 0}>
                {props.showActivities && (
                    <div className={classes.detailBox}>
                        <h4>Course Activities</h4>
                        <div className={classes.allActivities}>
                            <div className={classes.activityFilters + ' ' + classes.noPrint}>
                                <form action="" onSubmit={e => {e.preventDefault(); filterComps()}} autoComplete="off">
                                    <div className={classes.keywordsearch}>
                                        <input type="text" name="search" value={keywords} onChange={(e) => {setKeywords(e.target.value)}}/>
                                        <input type="submit" value="Clear"/>
                                    </div>
                                    <div className={classes.buttonsearch}>
                                        <div className={classes.expandAllActivities + ' ' + filterActs2} onClick={() => {setExpandAllActivities(!expandAllActivities)}}>
                                            Expand All Activities
                                        </div>
                                    </div>
                                </form>
                            </div>
                            {Object.keys(props.course.activities).map((activityId,kee) => {
                                var activity = props.course.activities[activityId];
                                var btnClass = activity.hidden ? classes.btnNotPressed : classes.btnPressed;

                                //console.log('activity info');
                                //console.log({activity:activity, expandAllActivities: expandAllActivities})
                                //verify toggleRollup
                                if(props.showActivities && Object.keys(activity.competencies).length > 0 ){
                                    return(
                                            <div className={classes.activityCompBox} key={kee}>
                                                <div className={classes.activityName + ' ' + btnClass}
                                                    onClick={() => {props.toggleRollup({actid:activity.activity.iteminstance, crsid:activity.activity.courseid})}}>
                                                        <h5><strong>{activity.activity.itemname}</strong></h5>
                                                </div>
                                                <TransitionExpand duration={500} height={(expandAllActivities || (!activity.hidden && Object.keys(activity.competencies).length > 0) ) ? 'auto' : 0}>
                                                    {(expandAllActivities || (!activity.hidden && Object.keys(activity.competencies).length > 0) )&& (
                                                        
                                                        <div className={classes.actComplist}>
                                                            {Object.keys(activity.competencies).map((acompid, keee) => {
                                                                var compid= activity.competencies[acompid];
                                                                if(checkFilter(props.fullcomplist[compid])){
                                                                    var klis = (props.activityshowlist[compid]) ? classes.shownSomewhere + ' ' + classes.btnPressed : classes.btnNotPressed;
                                                                    return(
                                                                        <div key={keee}
                                                                            className={classes.actCompBtn + ' ' + klis}
                                                                            onClick={() => {props.setActivityCompShowList({compid: compid, activityid: activity.activity.id}, props.courseid)}}
                                                                            >
                                                                            <TransitionExpand duration={500} height={props.activityshowlist[compid] == activity.activity.id  ? 'auto' : 0}>
                                                                                <span key={props.activityshowlist[compid]}
                                                                                    title={`${props.fullcomplist[compid].description} (ctrl+click to deselect others)`}>
                                                                                    {props.fullcomplist[compid].idnumber}
                                                                                    {props.activityshowlist[compid] == activity.activity.id && (
                                                                                        <> >  >  {props.fullcomplist[compid].description}</>
                                                                                    )}
                                                                                </span>
                                                                            </TransitionExpand>
                                                                        </div>
                                                                    )
                                                                }

                                                            })}
                                                            
                                                        </div>
                                                        )}
                                                </TransitionExpand>
                                            </div>
                                        
                                    )
                                }
                            })}
                        </div>
                        
                    </div>
                )}
            </TransitionExpand>
        </div>
    )
}